var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper landing-page"},[_c('div',{staticClass:"page-header page-header-small"},[_c('parallax',{staticClass:"page-header-image",staticStyle:{"background-image":"url('/img/pexels-photo-220320.jpeg')"}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-center"},[_c('h1',{staticClass:"title"},[_vm._v("App Payments")])])
}]

export { render, staticRenderFns }